import type { ReportLayoutConfig, ReportSectionConfig, SectionBuild } from '@/features/reports'

const overviewBuild: SectionBuild = () => ({
  id: '67-overview',
  reportId: 67,
  scheduleTabs: ['overview'],
  sortField: 'customer_first_name',
})

export const CUSTOMER_INTELLIGENCE_OVERVIEW_SECTION: ReportSectionConfig = {
  id: '67-overview',
  reportId: 67,
  hideChannels: true,
  tabs: [{ name: 'overview', tabs: ['overview'] }],
  build: overviewBuild,
}

/** Page chrome/date defaults; the route slot owns the legacy two-column composition. */
export const CUSTOMER_INTELLIGENCE: ReportLayoutConfig = [
  {
    name: 'Overview',
    labelKey: 'commerceAnalytics.customerIntelligence.tabs.overview',
    sections: [CUSTOMER_INTELLIGENCE_OVERVIEW_SECTION],
  },
]
